import { Component, Input, OnInit } from '@angular/core';
import { MessageBoxType } from '../models';
import { MatCard, MatCardTitleGroup, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  imports: [MatCard, MatCardTitleGroup, MatCardTitle, MatCardSubtitle, MatCardContent],
})
export class MessageBoxComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() text!: string;
  @Input() type!: MessageBoxType;

  constructor() {}

  ngOnInit(): void {}
}
